export default __webpack_public_path__ + "static/media/coronavirus_yellow.8799dc80.png";